import styled from "@emotion/styled";
import Background from '../../../assets/background.jpg';
import { themeColor } from "../../layout/global-style"
import { a } from 'react-spring'

export const Container = styled(a.div)`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-flow: row wrap;
  width: 100%;
  flex: 1 0 100%;
  background-image: url(${Background});
  background-repeat: no-repeat;
  background-position: bottom center;
  background-size: cover;
  background-attachment: fixed;
  height: 100%;
  position: absolute;
  top:0;
  min-height: 100%;
  overflow-y: auto;
  background-color: ${themeColor.white};
  pointer-events: all;
  @media screen and (orientation: portrait) {
    overflow:auto;
    -webkit-overflow-scrolling:touch;
    
  }

  @media screen and (max-height: 300px) {
    overflow-y: auto;
  }

  .title {
    span {
      font-size: 98px;
      @media screen and (max-width: 1919px) and (orientation: landscape) {
        font-size: 5vw;
      }
      @media screen and (max-width: 1024px) and (orientation: landscape) {
        font-size: 8vw;
      }
      @media screen and (max-width: 540px) and (orientation: portrait) {
        font-size: 72px;
      }
    }
  }

`

export const Wrapper = styled.div`
  max-width: 1920px;
  margin: 0 auto;
  display: flex;
  width: 100%;
  position: relative;
  align-items: flex-start;
  justify-content: center;
  min-height: 100%;
  flex-flow: row wrap;
  padding-top: 106px;
  @media screen and (orientation: portrait) {
    align-items: flex-start;
    justify-content: center;
    align-content: flex-start;
    height: 100%;
  }

  @media screen and (max-width: 1024px) and (min-height: 680px) and (orientation: landscape) {
    align-items: flex-start;
    align-content: flex-start;
  }
`;


export const Content = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-flow: row wrap;
  color: #${themeColor.black};
  position: relative;
  z-index: 0;
  margin-bottom: 128px;
  h1 {
    font-size: 64px;
    margin-bottom: 10px;
    width: 100%;
    @media screen and (max-width: 1919px) and (orientation: landscape) {
      font-size: 3.3vw;
      margin-bottom: .54vw;
    }
    @media screen and (max-width: 1366px) and (min-height: 950px) and (max-height: 1024px) {
      font-size: 5.8vw;
    }
    @media screen and (max-width: 768px) and (orientation: portrait) {
      font-size: 50px;
      margin-bottom: 4px;
    }
    @media screen and (max-width: 540px) and (orientation: portrait) {
      font-size: 48px;
    }
    @media screen and (max-width: 1024px) and (orientation: landscape) {
      font-size: 6vw;
    }
    @media screen and (max-width: 360px) and (orientation: portrait) {
      font-size: 42px;
    }
  }

  > p {
    font-size: 18px;
    @media screen and (max-width: 1919px) and (orientation: landscape) {
      font-size: .94vw;
      margin-bottom: 1.02vw;
    }
    @media screen and (max-width: 768px) and (orientation: portrait) {
      font-size: 16px;
    }
    @media screen and (max-width: 540px) and (orientation: portrait) {
      font-size: 20px;
      line-height: 120%;
    }
    @media screen and (max-width: 1024px) and (orientation: landscape) {
      font-size: 2.2vw;
    }
  }

  @media screen and (orientation: portrait) {
    max-width: 100%;
    margin-right: 0;
    margin-bottom: 3vw;
  }

  @media screen and (max-width: 1919px) and (orientation: landscape) {
    margin-bottom: 3  .68vw;
  }

  @media screen and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 2.68vw;
  }

  @media screen and (max-width: 540px) and (orientation: portrait) {
    padding: 0 18px;
  }

  @media screen and (max-width: 1024px) and (min-height: 680px) and (orientation: landscape) {
    margin: 0 auto;
  }

  .btn.btn--small.btn--bottom-label  {
    .btn__content {
      @media screen and (max-width: 1919px) and (orientation: landscape) {
        padding-left: 1.56vw;
        padding-right: .73vw;
        padding-top: .63vw;
        > div {
          width: 1.67vw;
  
          svg {
            width: 1.67vw;
            height: 1.67vw;
          }
        }
      }
      @media screen and (max-width: 1024px) and (orientation: landscape) {
        padding-right: 1vw;
        > div {
          width: 2vw;
          svg {
            width: 2vw;
            height: 2vw;
          }
        }
      }
      @media screen and (max-width: 1024px) and (orientation: landscape) and (max-height: 600px) {
        > div {
          width: 2.5vw;
          svg {
            width: 2.5vw;
            height: 2.5vw;
          }
        }
      }

      @media screen and (max-width: 768px) and (orientation: portrait){
        padding-left: 22px;
      }
      .btn__text {
        @media screen and (max-width: 1919px) and (orientation: landscape) {
          font-size: 1.46vw;
          padding-right: .53vw;
        }
        @media screen and (max-width: 1024px) and (orientation: landscape) {
          font-size: 2.3vw;
          padding-right: 0;
        }

        @media screen and (max-height: 320px) and (orientation: landscape) {
          font-size: 2.1vw;
        }
        @media screen and (max-width: 768px) and (orientation: portrait) {
          font-size: 20px;
        }
        @media screen and (max-width: 360px) and (orientation: portrait) {
          font-size: 20px;
        }
      }
    }
    .btn__bottom {
      &-left {
        @media screen and (max-width: 1919px) and (orientation: landscape) {
          width: .83vw;
          height: .83vw;
          border-top-width: .83vw;
          border-left-width: .83vw;
        }
        @media screen and (max-width: 1024px) and (orientation: landscape) {
          width: 1.1vw;
          height: 1.1vw;
          border-top-width: 1.1vw;
          border-left-width: 1.1vw;
        }
        @media screen and (max-width: 1024px) and (orientation: landscape) and (max-height: 600px) {
          width: 1.1vw;
          height: 1.1vw;
          border-top-width: 1.1vw;
          border-left-width: 1.1.vw;
        }
      }
      &-center {
        @media screen and (max-width: 1919px) and (orientation: landscape) {
          height: .83vw;
          width: calc(100% - .83vw - 2.1vw);
        }
        @media screen and (max-width: 1024px) and (orientation: landscape) {
          height: 1.1vw;
          width: calc( 100% - 1.1vw - 3.1vw);
        }
        @media screen and (max-width: 1024px) and (orientation: landscape) and (max-height: 600px) {
          height: 1.1vw;
          width: calc(100% - 1.1vw - 3.1vw);
        }
      }
      &-right {
        @media screen and (max-width: 1919px) and (orientation: landscape) {
          width: 2.1vw;
          height: .83vw;
          border-right-width: .83vw;
          border-top-width: .47vw;
          &:after {
            font-size: .52vw;
            bottom: -.36vw;
            left: .26vw;
          }
        }

        @media screen and (max-width: 1024px) and (orientation: landscape) {
          width: 3.1vw;
          height: 1.1vw;
          border-right-width: 1.1vw;
          border-top-width: .37vw;
          &:after {
            font-size: .72vw;
            bottom: - .56vw;
            left: .46vw;
          }
        }

        @media screen and (max-width: 1024px) and (orientation: landscape) and (max-height: 600px) {
          width: 3.1vw;
          height: 1.1vw;
          border-right-width: 1.1vw;
          border-top-width: .37vw;
          &:after {
            font-size: .72vw;
            bottom: - .56vw;
            left: .46vw;
          }
        }
      }
    }

  } 
`

export const ListContainer = styled.div`
  display: flex;
  flex-direction:column;
  align-items: center;
  justify-content: center;
  flex: 1 0 100%;
  width: 100%;
  flex-flow: row wrap;
  max-width: 1096px;

  @media screen and (max-width: 768px) and (orientation: portrait) {
    padding: 0 48px;
  }

  @media screen and (max-width: 660px) and (orientation: portrait) {
    padding: 0 20px;
  }

  @media screen and (max-width: 540px) and (orientation: portrait) {
    padding: 0;
  }
`

export const LogoContainer = styled.div`
  display: flex;
  img {
    height: 64px;
  }
  @media screen and (max-width: 768px){
    img {
      height: 40px;
    }
  }
`;
export const LangSelectionContainer = styled.div`
    display: flex;
    padding-top: 1em;

    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-flow: row wrap;
    width: 100%;
    flex: 1 0 100%;
    p {
      width: 100%;
    }
`    

export const LocaleContainer = styled.div`
    display: flex;
    position: relative;
    flex-direction:column;
    width: 200px;
    height: auto;
    margin: 5px 5px;

    @media screen and (max-width: 768px) {
        svg{
            height: 24px;
        }
    }
`;
